import "../../css/widgets/widgets.css";

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import MonitorWSService from '../../services/monitorwsservice';
import WidgetSettings from "./widgetSettings"
import { removeWidget } from "../../redux/supervisorSlice";
import { selectionTypes } from "../utils/consts";
import WidgetTools from "./widgetTools";
import { faFacebook, faInstagram, faTelegram, faTwitter, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faRainbow, faSms, faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { Center } from "devextreme-react/map";

function OutgoingChatsSummary(props) {

    const { t } = useTranslation();
    const [all, setAll] = useState(0);
    const [sent, setSent] = useState(0);
    const [failed, setFailed] = useState(0);
    const [delivered, setDelivered] = useState(0);
    const [read, setRead] = useState(0);
    const [showSettings, setShowSettings] = useState(false);
    const [groupId, setGroupId] = useState(-1);
    const [groupName, setGroupName] = useState(localStorage.getItem(`OutgoingChatsSummary_groupName_${props.identifier}_user${props.id}`) || t("all2"));
    const [channel, setChannel] = useState(localStorage.getItem(`OutgoingChatsSummary_channel_${props.identifier}_user${props.id}`) || "");
    const [channelName, setChannelName] = useState(localStorage.getItem(`OutgoingChatsSummary_channelName_${props.identifier}_user${props.id}`) || "");

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send(`/app/unsubscribe/outgoingchatssummary`, {}, JSON.stringify({
                    token: props.token,
                    widgetId: props.identifier
                }));

                MonitorWSService.stompClient.unsubscribe(`outgoingchatssummary_${props.identifier}`);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.connected) {
            let groupId = parseInt(localStorage.getItem(`OutgoingChatsSummary_groupId_${props.identifier}_user${props.id}`) || -1);
            let channel = localStorage.getItem(`OutgoingChatsSummary_channel_${props.identifier}_user${props.id}`) || "";
            setGroupId(groupId)
            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/outgoingchatssummary_${props.identifier}/`, function (chatssummary) {
                if (!document.hidden && localStorage.getItem("resizing") !== "true") {
                    var data = JSON.parse(chatssummary.body);
                    setAll(data.total);
                    setSent(data.sent);
                    setFailed(data.failed);
                    setDelivered(data.delivered);
                    setRead(data.read);
                }
            }, { id: `outgoingchatssummary_${props.identifier}` });

            MonitorWSService.stompClient.send("/app/subscribe/outgoingchatssummary", {}, JSON.stringify({
                token: props.token,
                widgetId: props.identifier,
                groupId: groupId,
                channel: channel
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroupAndChannel = (groupId, groupName, channel, channelName) => {

        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        setChannel(channel);
        setChannelName(channelName);

        localStorage.setItem(`OutgoingChatsSummary_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`OutgoingChatsSummary_groupName_${props.identifier}_user${props.id}`, groupName);
        localStorage.setItem(`OutgoingChatsSummary_channel_${props.identifier}_user${props.id}`, channel);
        localStorage.setItem(`OutgoingChatsSummary_channelName_${props.identifier}_user${props.id}`, channelName);

        MonitorWSService.stompClient.send("/app/subscribe/outgoingchatssummary", {}, JSON.stringify({
            token: props.token,
            groupId: groupId,
            widgetId: props.identifier,
            channel: channel
        }));


    };
    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }
    const getIcon = (channel) => {
        let elem = <FontAwesomeIcon icon={duotone("reply")} />;
        if (channel === "facebook")
            elem = <FontAwesomeIcon icon={faFacebook} />;
        if (channel === "whatsapp")
            elem = <FontAwesomeIcon icon={faWhatsapp} />;
        if (channel === "instagram")
            elem = <FontAwesomeIcon icon={faInstagram} />;
        if (channel === "twitter")
            elem = <FontAwesomeIcon icon={faTwitter} />;
        if (channel === "sms")
            elem = <FontAwesomeIcon icon={faSms} />;
        if (channel === "telegram")
            elem = <FontAwesomeIcon icon={faTelegram} />;
        if (channel === "rainbow")
            elem = <FontAwesomeIcon icon={faRainbow} />;
        if (channel === "mail")
            elem = <FontAwesomeIcon icon={faEnvelope} />;
        return elem;
    }
    return (
        <div className="card card-flush overflow-hidden h-lg-20 widget-container" >
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary">{getIcon(channel)} {channelName ? channelName : t("outgoingchatssummary")} - {groupName}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col md={2} style={{ flex: '0 0 20%', textAlign: "center" }}>
                        <div className="fs-3hx fw-bold text-gray-800 statsnumber">{all}</div>
                        <div className="fs-5 fw-semibold mb-7">{t("total")}</div>
                    </Col>
                    <Col md={2} style={{ flex: '0 0 20%', textAlign: "center" }}>
                        <div className="fs-3hx fw-bold text-warning statsnumber">{sent}</div>
                        <div className="fs-5 fw-semibold mb-7">{t("sent")}</div>
                    </Col>
                    <Col md={2} style={{ flex: '0 0 20%', textAlign: "center" }}>
                        <div className="fs-3hx fw-bold text-success statsnumber">{read}</div>
                        <div className="fs-5 fw-semibold mb-7">{t("read")}</div>
                    </Col>
                    <Col md={2} style={{ flex: '0 0 20%', textAlign: "center" }}>
                        <div className="fs-3hx fw-bold text-primary statsnumber">{delivered}</div>
                        <div className="fs-5 fw-semibold mb-7">{t("delivered")}</div>
                    </Col>

                    <Col md={2} style={{ flex: '0 0 20%', textAlign: "center" }}>
                        <div className="fs-3hx fw-bold text-danger statsnumber">{failed}</div>
                        <div className="fs-5 fw-semibold mb-7">{t("failed")}</div>
                    </Col>
                </Row>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroupAndChannel={setGroupAndChannel} groupId={groupId} groupName={groupName} selectionType={selectionTypes.CHANNEL} channel={channel} channelName={channelName}></WidgetSettings>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, { removeWidget })(OutgoingChatsSummary);